import React from "react";
import "@/App.css";
import "@/styles/custom.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Profile } from "@/components/Profile";
import { Portfolio } from "@/components/Portfolio";
import { HukumPedia } from "@/components/HukumPedia";
import { Articles } from "@/components/Articles";
import { RegulationSearch } from "@/components/RegulationSearch";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Profile />
      <Portfolio />
      <HukumPedia />
      <Articles />
      <RegulationSearch />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
